import { useEffect, useState } from 'react';
import { officeReady } from '@/services/office';

/** Blocks until Office.onReady fires (or resolves immediately in browser). */
export function useOfficeReady(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    officeReady().then(() => {
      if (!cancelled) setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return ready;
}
